<template>
  <div class="h-100">
    <v-card elevation="0" outlined class="h-100 d-flex flex-column overflow-x-auto" min-height="350">
      <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;"
        :class="$vuetify.theme.dark ? 'black' : 'primary'">
        <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
          <v-icon color="white" class="mr-2" medium>assignment</v-icon>
          <span
            class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ $t("dashboards.reportsRequested") }}</span>
        </div>
        <v-btn class="pl-0 pr-0" text small :to="`/inbox`" style="flex-shrink: 0;">
          <span class="white--text text-decoration-underline font-weight-bold">{{ $t('dashboards.goInbox') }}</span>
          <v-icon small class="ml-1" color="white">keyboard_arrow_right</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="d-flex flex-column flex-grow-1 pa-0" style="min-height: 0;">
        <template v-if="reports && !loading">
          <div class="d-flex flex-grow-1 flex-column flex-md-row" style="padding-top: 0px !important;">
            <div class="d-flex flex-grow-1 " v-for="(report, index) in reports" :key="index">
              <InboxReportItem v-bind:class="{ 'ml-1': index != 0 && $vuetify.breakpoint.mdAndUp }" :report="report"
                :embedded="true" :states="states"></InboxReportItem>
              <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            </div>
          </div>
          <div class="d-flex flex-column pl-3 pr-3 pb-1 py-4 mb-7 text-center flex-grow-1"
            v-if="!reports || !reports.length">
            <v-icon color="primary lighten-5" style="font-size:80px">help_outline</v-icon>
            <span class="primary--text lighten--text-2 body-1">{{ $t("dashboards.placeholderReports") }}</span>
          </div>
        </template>

        <template v-else>
          <div class="mt-4 pl-6 pr-4 d-flex align-center justify-space-between">
            <v-skeleton-loader type="text" width="30%" class="ma-0"></v-skeleton-loader>
            <v-skeleton-loader type="text" width="15%" class="ma-0"></v-skeleton-loader>
          </div>
          <div class="px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around">
            <v-skeleton-loader v-for="i in 4" :key="i" type="text" width="100%" class="my-2"></v-skeleton-loader>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportService from "../../../services/report.service";
import InboxReportItem from "../../inbox/InboxReportItem";
import * as moment from "moment";
import * as _ from "lodash";
import ResizeObserver from 'resize-observer-polyfill';

export default {
  name: "ReportsWidget",
  props: {},
  components: {
    InboxReportItem
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  data() {
    return {
      reports: null,
      loading: false,
      observer: null,
      states: []
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
    this.observer = new ResizeObserver(this.onResize).observe(this.$el);
  },
  destroyed() {
    delete this.observer;
  },
  methods: {
    onResize() {
      this.$emit("heightChange", this.$el.clientHeight);
    },
    loadViewData() {
      this.loadReports();
      this.getStates();
    },
    async loadReports() {
      this.loading = true;
      let reportsResponse = await ReportService.getAllDeepReportVisible();
      this.reports = _.chain(reportsResponse.data)
        .filter(r => this.currentUser.clientType === 'Driblab' || r.userId === this.currentUser.id)
        .forEach(
          r =>
            (r.createdTime = moment(r.createdAt, "DD/MM/YYYY HH:mm").valueOf())
        )
        .orderBy("createdTime", "desc")
        .slice(0, 3)
        .value();
      this.loading = false;
    },
    getStates: async function () {
      let statesResponse = await ReportService.getAllTypeStates();
      this.states = statesResponse.data;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/widgets/ReportsWidget.vue